export const faqList = [
  {
    question: '푸시 알림이 안 와요.',
    content: [
      {
        title: `< 주의사항 >`,
        list: [
          `푸시 알림은 스마트폰으로만 받을 수 있어요.`,
          `iOS는 'Safari - 홈 화면에 추가(PWA 설치)' 환경에서만 푸시 알림을 지원해요.`,
          `Android는 Chrome 브라우저 사용을 권장해요.`,
          `인스타그램, 네이버 등 인앱 브라우저는 푸쉬 알림을 지원하지 않아요.`,
        ],
      },
      {
        title: `< 알림 설정 방법 >`,
        list: [
          `1️⃣ 하단 메뉴 [알림] → 우측 상단 ⚙️(톱니바퀴) 아이콘 → '알림 받기' 토글을 ON으로 변경해주세요.`,
          `2️⃣ 처음 알림을 설정하는 경우 "알림 권한 요청" 창이 나타나요. '허용'을 누른 후 설정이 반영되기까지 최대 5초 정도 걸려요.`,
          `3️⃣ 알림 권한을 거절한 경우 아래 OS별 지침을 따라주세요.`,
        ],
        listStyle: 'none',
      },
      {
        title: `[Android]`,
        list: [
          `Chrome(또는 사용 중인 브라우저) 설정 → 사이트 설정 → 알림 → snorose.com → '허용'으로 변경해주세요.`,
          `홈 화면 추가(PWA)로 이용하는 경우도 브라우저 설정에서 사이트 알림 권한을 '허용'으로 바꿔야 해요.`,
        ],
      },
      {
        title: `[iOS]`,
        list: [
          `'홈 화면 추가(PWA)' 상태에서 진행해주세요. (Safari 하단 공유 아이콘 → '홈 화면에 추가' 선택)`,
          `아이폰 설정 → 앱 → 스노로즈 → 알림 → '허용'으로 변경해주세요.`,
        ],
      },
      {
        title: `💡 알림이 오지 않는다면`,
        list: [
          `'알림 받기' 토글이 켜져 있고, 브라우저/기기 알림 권한이 '허용' 상태인지 확인해주세요.`,
        ],
      },
    ],
  },
  {
    question: '시험후기 다운로드가 안돼요.',
    content: [
      {
        title: `시험후기 다운로드가 정상적으로 되지 않을 경우,\n문제가 발생한 시험후기 제목과 링크, 오류 내용을 공식 문의 창구로 남겨주세요.\n확인 후 최대한 빠르게 도와드리겠습니다.`,
      },
    ],
  },
  {
    question:
      '이전에 다운로드한 시험후기를 다시 다운로드해도 포인트가 차감되나요?',
    content: [
      {
        title: `동일한 시험후기를 다시 다운로드하실 경우, 포인트는 차감되지 않습니다.`,
      },
    ],
  },
  {
    question: '시험후기 정보가 잘못 기재된 경우 어떻게 하나요?',
    content: [
      {
        title: `분반, 문항 수, 중복 업로드 등 족보 정보에 오류가 있는 경우,\n해당 시험후기 제목, 족보 링크, 오류 내용을 공식 문의 창구로 남겨주세요.\n확인 후 처리 여부를 안내드리겠습니다.`,
      },
    ],
  },
  {
    question: '인증 이메일이 오지 않아요.',
    content: [
      {
        title: `입력하신 이메일 주소가 정확한지 다시 한 번 확인해 주세요.\n시스템 상황에 따라 메일이 지연되거나 스팸 메일함으로 분류될 수 있습니다.\n\n재시도 후에도 메일을 받지 못하신 경우, 학번과 이메일 주소를 함께 공식 문의 창구로 전달해 주시면 확인해 드리겠습니다.`,
      },
    ],
  },
  {
    question: '인증이 계속 반려돼요.',
    content: [
      {
        title: `인증 시에는 스노로즈 비밀번호가 아닌, 숙명포털 비밀번호를 입력해 주셔야 합니다.\n또한 자동완성으로 인해 예기치 않은 띄어쓰기가 포함되지 않았는지 확인해 주세요.\n위 방법으로도 해결되지 않을 경우, 브라우저를 변경하시거나 시크릿(익명) 모드로 접속해 한 번 더 시도해 주세요.`,
      },
    ],
  },
  {
    question: '이메일/학번을 변경하고 싶어요.',
    content: [
      {
        title: `가입 당시 사용하신 이메일이 유효하지 않거나 존재하지 않는 경우,\n또는 학번 입력 오류로 아이디 찾기가 어려운 경우 아래 구글폼을 통해 변경 요청을 제출해 주세요.\n본인 확인이 완료되면, 이메일로 처리 결과를 안내드리겠습니다.`,
      },
      {
        title: `<구글폼> \n https://forms.gle/xwi7q47Dz59UNeEW7`,
      },
    ],
  },

  {
    question:
      '댓글이나 글 작성으로 받을 수 있는 포인트는 하루 최대 몇 포인트인가요?',
    content: [
      {
        title: `댓글이나 게시글 작성으로 지급되는 포인트는 하루 최대 20포인트입니다.`,
      },
    ],
  },
  {
    question: '스노로즈에 후원하고 싶어요.',
    content: [
      {
        title: `스노로즈에 후원에 관심을 가져주셔서 감사합니다.\n후원과 관련된 계좌 정보 및 자세한 안내는 아래 링크에서 확인하실 수 있습니다.\n\nhttps://www.notion.so/snorose/1147ef0aa3bf8024a774dde3d6e69d00`,
      },
    ],
  },
];
